import { Role } from "@/acl/roles";
import { PRODUCTS_DETAILS } from "@/assets/constants/products/hexagon-capital";

export default {
  orgName: "Hexagon Capital",
  logoPath: require("@/assets/images/logo/hexagon-capital.svg"),
  navBarLogoStyle: "width: 100%;",
  allowedLoginMethods: ["Google"],
  products: PRODUCTS_DETAILS,
  possibleRoles: [Role.superAdmin, Role.admin],
  admin: true,
  availableLanguages: ["en", "fr"],
};
